import { Observable } from "rxjs"
import { ObservableFromFetch } from "../../ObservableFromFetch"
import ImportJobActionResult from "./Model/ImportJobActionResult"

export default function ImportJobCreateAndPerformObservable(
  base64string: string, hasHeaderRow: boolean, fileName?: string,
  companyID?: number, poolID?: number,
  isGovtPersonnel?: boolean, isCompanyCodeRequired?: boolean): Observable<ImportJobActionResult> {
  const params: string = JSON.stringify({
    AccountType: 2,
    CSVFileBase64String: base64string,
    FileName: fileName,
    HasHeaderRow: hasHeaderRow,
    UseTemplate: false,
    ImportJobID: 0,
    CompanyID: companyID || 0,
    GovtPersonnel: isGovtPersonnel,
    WorkforcePersonnel: !isGovtPersonnel,
    PoolID: poolID || 0,
    CompanyCodeRequired: isCompanyCodeRequired,
    MultiplePools: false
  })

  return ObservableFromFetch<ImportJobActionResult>("WorkforceImport/CreateAndPerformImportJob", params)
}
